import {SOURCE_RASTER, SOURCE_VECTOR, SOURCE_WMS} from 'Map/tier/styleParts/styleResolver';

export default function vectorRasterWmsTester(source, vectorPattern, rasterPattern, wmsPattern) {
    switch (source) {
    case SOURCE_VECTOR:
        return (url) => vectorPattern.test(url);
    case SOURCE_RASTER:
        return (url) => rasterPattern.test(url);
    case SOURCE_WMS:
        return (url) => wmsPattern.test(url);
    default:
        throw new Error(`Unknown source: ${source}`);
    }
}



// WEBPACK FOOTER //
// ./map/tier/urlTransformers/vectorRasterWmsTester.js